const account_center = {
    not_enabled: 'Центр аккаунта не включен.',
    filed_not_editable: 'Поле не редактируется.',
};
export default Object.freeze(account_center);
